<template>
  <div>
    <div class="Breadcrumb u-desktopOnly">
      <ul>
        <li class="Breadcrumb__item"><router-link to="/">{{ $t("home") }}</router-link></li>
        <li class="Breadcrumb__item"><router-link to="/terms-and-conditions">{{ $t("termsAndConditions") }}</router-link></li>
        <li class="Breadcrumb__item"><span>{{ $t("seasonDigipass") }}</span></li>
      </ul>
    </div>

    <div class="PageHeader">
      <h1 class="PageHeader__heading">{{ $t("termsAndConditions") }}</h1>
    </div>
    <div class="HeroImage">
      <img src='./../../assets/bg/people-having-fun.jpg' alt="">
    </div>
    <div class="RichTextArea">
      <h2>{{ $t("seasonDigipass") }}</h2>

      <div v-html="$t('tcCommon')"></div>
      <div v-html="$t('tcSeasonDigipass')"></div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'TCSeasonDigipass',
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/TermsAndConditions/SeasonDigipass.vue